import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceTransaction {
    lookupService = new APIServiceLookUp();

    async addTransaction(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}transaction/addTransaction`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateTransaction(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}transaction/updateTransaction`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getAllTransaction(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}transaction/getAllTransaction`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getWalletById(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}transaction/getWalletById`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

}